import React from "react";
import Maincontent from "./pages/Maincontent";

const ReportPage = () => {
  return (
    <>
      <div className="reportPage">
        <Maincontent />
      </div>
    </>
  );
};

export default ReportPage;
